/* eslint-disable */
import React from "react";
import Calendar_Icon from "../icons/Calendar_Icon";
import Options_Icon from "../icons/Options_Icon";
import User_Icon from "../icons/User_Icon";
import Informartion_Icon from "../icons/Information_Icon";

export default function OptionsTooltip() {
  return (
    <div className="tooltip">
      <span className="tooltiptext">
        <h4>Bienvenido, aprende a usar esta página!</h4>
        <p style={{ textAlign: "justify" }}>
          <span className="label" style={{ textAlign: "justify" }}>
            1.-
          </span>
          Para acceder a la información del conductor haz click sobre el icono{" "}
          <span>
            <User_Icon color={"#000000"} />
          </span>
        </p>
        <p style={{ textAlign: "justify" }}>
          <span className="label" style={{ textAlign: "justify" }}>
            2.-
          </span>
          Para seleccionar rangos de fecha personalizados haz click en el icono
          y selecciona el rango de fechas que deseas. <br /> *Toma en cuenta que
          la fecha inicial incia a las 00:00:00 hras y la fecha final finaliza
          23:59:59{" "}
          <span>
            <Calendar_Icon color={"#333"} />
          </span>
        </p>
        <p style={{ textAlign: "justify" }}>
          <span className="label" style={{ textAlign: "justify" }}>
            3.-
          </span>
          Puedes ver más opciones en el icono{" "}
          <span>
            <Options_Icon color={"#000000"} />
          </span>{" "}
          puedes exportar el estado de cuenta a formato excel o pdf y enviar el
          estado de cuenta en formato pdf al conductor correspondiente
        </p>
      </span>

      <Informartion_Icon />
    </div>
  );
}
